/* JMT search overlay: Shopify Predictive Search through the Section Rendering API, recent searches,
   keyboard navigation. */
(() => {
  'use strict';

  const dialog = document.getElementById('jmt-search');
  const jmt = window.jmt;
  if (!dialog || !jmt || !jmt.utils) return;

  const { store, debounce } = jmt.utils;
  const input = dialog.querySelector('[data-jmt-search-input]');
  const form = dialog.querySelector('[data-jmt-search-form]');
  const results = dialog.querySelector('[data-jmt-search-results]');
  const clearButton = dialog.querySelector('[data-jmt-search-clear]');
  const recentBox = dialog.querySelector('[data-jmt-recent]');
  const recentList = dialog.querySelector('[data-jmt-recent-list]');
  const { predictiveUrl, searchUrl, sectionId } = dialog.dataset;
  const RECENT_KEY = 'jmt:recent-searches';
  const RECENT_MAX = 5;
  let controller;

  const escapeHtml = (value) =>
    String(value).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);

  const setState = (state) => {
    dialog.dataset.state = state;
    input.setAttribute('aria-expanded', String(state === 'results'));
  };

  const recents = () => store.get(RECENT_KEY, []);
  const saveRecent = (term) => {
    const clean = String(term || '').trim();
    if (!clean) return;
    store.set(RECENT_KEY, [clean, ...recents().filter((item) => item.toLowerCase() !== clean.toLowerCase())].slice(0, RECENT_MAX));
  };
  const renderRecents = () => {
    const list = recents();
    recentBox.hidden = list.length === 0;
    recentList.innerHTML = list
      .map((term) => {
        const safe = escapeHtml(term);
        return `<li><span class="jmt-chip jmt-chip--removable"><a href="${searchUrl}?q=${encodeURIComponent(term)}" data-jmt-search-term="${safe}">${safe}</a><button type="button" class="jmt-chip__remove" data-jmt-recent-remove="${safe}" aria-label="Remove ${safe} from recent searches">&times;</button></span></li>`;
      })
      .join('');
  };

  const reset = () => {
    if (controller) controller.abort();
    results.innerHTML = '';
    setState('idle');
  };

  const search = async (query) => {
    if (controller) controller.abort();
    controller = new AbortController();
    setState('loading');
    const params = new URLSearchParams({
      q: query,
      section_id: sectionId,
      'resources[type]': 'product,collection,page,query',
      'resources[limit]': '6',
      'resources[limit_scope]': 'each',
      'options[prefix]': 'last',
    });
    try {
      const response = await fetch(`${predictiveUrl}?${params}`, { signal: controller.signal });
      if (!response.ok) throw new Error(String(response.status));
      const html = await response.text();
      if (input.value.trim() !== query) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('[data-jmt-has-results], [data-jmt-empty]');
      results.innerHTML = content ? content.outerHTML : '';
      setState(doc.querySelector('[data-jmt-has-results]') ? 'results' : 'empty');
    } catch (error) {
      if (error.name !== 'AbortError') reset();
    }
  };

  const onInput = debounce(() => {
    const query = input.value.trim();
    if (query.length < 2) reset();
    else search(query);
  }, 250);

  input.addEventListener('input', () => {
    clearButton.hidden = !input.value;
    if (input.value.trim().length < 2) reset();
    onInput();
  });
  form.addEventListener('reset', () => {
    setTimeout(() => {
      clearButton.hidden = true;
      reset();
      input.focus();
    });
  });
  form.addEventListener('submit', () => saveRecent(input.value));

  dialog.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-jmt-recent-remove]');
    if (remove) {
      const term = remove.dataset.jmtRecentRemove;
      store.set(RECENT_KEY, recents().filter((item) => item !== term));
      renderRecents();
      return;
    }
    if (event.target.closest('[data-jmt-recent-clear]')) {
      store.set(RECENT_KEY, []);
      renderRecents();
      return;
    }
    const link = event.target.closest('a[data-jmt-search-term]');
    if (link) {
      saveRecent(link.dataset.jmtSearchTerm);
      return;
    }
    if (event.target.closest('[data-jmt-result]')) saveRecent(input.value);
  });

  dialog.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    const items = Array.from(dialog.querySelectorAll('[data-jmt-result]'));
    if (!items.length) return;
    event.preventDefault();
    const index = items.indexOf(document.activeElement);
    const next = event.key === 'ArrowDown' ? items[index + 1] || items[0] : index <= 0 ? input : items[index - 1];
    next.focus();
  });

  dialog.addEventListener('jmt:drawer:open', () => {
    renderRecents();
    setState(input.value.trim().length >= 2 ? 'results' : 'idle');
    requestAnimationFrame(() => input.focus());
  });
  dialog.addEventListener('jmt:drawer:close', () => {
    input.value = '';
    clearButton.hidden = true;
    reset();
  });
})();
